import { useUsersByUserOrgQuery } from "@sso/apis/users";
import FormikSelectWithBlur from "@sso/components/Formik/FormikSelectWtihBlur";
import { LicenceKeys } from "@sso/types";

interface UserByUserOrgSelectProps {
  organisationId: number | undefined;
}

const UserByUserOrgSelect = ({ organisationId }: UserByUserOrgSelectProps) => {
  const { data, isSuccess } = useUsersByUserOrgQuery(organisationId);
  const userOptions = data?.map(x => ({ key: x.userId, value: x.userId, label: x.fullName })) || [];
  return <>{isSuccess && <FormikSelectWithBlur name={LicenceKeys.USER_ID} label="User" items={userOptions} />}</>;
};

export default UserByUserOrgSelect;
